import React, { useState } from 'react';
import { Col, Input, Row, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem  } from 'reactstrap';
import Select from 'react-select';
import { addPaymentOptions, paymentOptions } from '../../../snippets/snippets';
import { NewsLetterStyle } from '../../../StyledComponents';
import { IoCaretBackOutline } from 'react-icons/io5';
import AddCreditCard from '../Payment Info/PaymentOptions/AddCreditCard';
import AddBankAccount from '../Payment Info/PaymentOptions/AddBankAccount';
import AddPayPal from '../Payment Info/PaymentOptions/AddPayPal';

const ReloadGiftCard = (props) => {
    const { data, showState, onCancel } = props;

    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedAddPaymentOption, setSelectedAddPaymentOption] = useState(null);

    const handleChange = (selectedOption) => {
      setSelectedOption(selectedOption);
      console.log('Selected payment method:', selectedOption);
    };

    const handleAddPaymentChange = (selectedOption) => {
        setSelectedAddPaymentOption(selectedOption);

        setShowForm(true);
    };


    const [showForm, setShowForm] = useState(false);

    
    const customStyles = {
        option: (provided) => ({
          ...provided,
          fontSize: '14px', // Change font size here
        }),
        control: (provided) => ({
          ...provided,
          fontSize: '16px', // Change font size for the control here if needed
        }),
        singleValue: (provided) => ({
          ...provided,
          fontSize: '14px', // Change font size of the selected value here
        }),
      };
console.log('selectedAddPaymentOption', selectedAddPaymentOption)
    return (
        <>
        {showForm ? (
      <>
                {
                    selectedAddPaymentOption.value == "credit_debit" ?
                        <AddCreditCard name={'Reload Gift Card'} data={data} showState={''} onSwitchTab={''} onCancel={() => setShowForm(false)} />
                    : selectedAddPaymentOption.value == "bank_account" ?
                    <AddBankAccount name={'Reload Gift Card'} data={data} showState={''} onSwitchTab={''} onCancel={() => setShowForm(false)} /> 
                    : selectedAddPaymentOption.value == "paypal" ?
                    <AddPayPal name={'Reload Gift Card'} data={data} showState={''} onSwitchTab={''} onCancel={() => setShowForm(false)} /> 
                    : ''
                }

      </>
  ) : (
        <div>
            <Row>
                <Col  xl='1' lg='1' md='1' sm='12' xs='12'>
                     <NewsLetterStyle style={{ fontSize: '18px', cursor: 'pointer' }} onClick={() => onCancel(false)}> <IoCaretBackOutline /> Back</NewsLetterStyle>
                
                </Col>
                <Col  xl='11' lg='11' md='11' sm='12' xs='12'>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                      <NewsLetterStyle style={{ fontWeight: '700' }}>Reload Gift Card</NewsLetterStyle>
                    </div>
                    <Row>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                            <Row style={{ marginBottom: '1rem', padding: '5px' }}>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Gift Card Number:</Col>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data?.giftCardNo || ''}</Col>
                            </Row>
                            <Row style={{ marginBottom: '1rem', padding: '5px' }}>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Current Balance:</Col>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data?.amount}</Col>
                            </Row>
                            <Row style={{ marginBottom: '1rem', padding: '5px' }}>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Reload Amount:</Col>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                                    <Input type='number' placeholder='Enter Amount' />
                                </Col>
                            </Row>
                            
                        </Col>
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <Row style={{ marginBottom: '1rem', padding: '5px' }}>
                                <Col xl='3' lg='3' md='3' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Payment Method:</Col>
                                <Col xl='9' lg='9' md='9' sm='12' xs='12'>
                                    <div style={{display:'flex', flexDirection:'row', width:'80%'}}>
                                        <Row className='w-100'>
                                            <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                                            <Select
                                            value={selectedOption}
                                            onChange={handleChange}
                                            options={paymentOptions}
                                            styles={customStyles}
                                            placeholder="Select a payment method"
                                        />
                                        </Col>
                                            <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                                            <UncontrolledDropdown>
                                                    <DropdownToggle caret color="warning" style={{ width: '100%',display:'flex',justifyContent:'space-between', alignItems:'center', backgroundColor: '#FBBD34', }}>
                                                        {selectedAddPaymentOption ? selectedAddPaymentOption.label : "Add payment method"}
                                                    </DropdownToggle>
                                                    <DropdownMenu style={{ width: '100%' }}>
                                                        {addPaymentOptions.map(option => (
                                                            <DropdownItem key={option.value} onClick={() => handleAddPaymentChange(option)}>
                                                                {option.label}
                                                            </DropdownItem>
                                                        ))}
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </Col>
                                        </Row>
                                    

                                    </div>
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: '1rem', padding: '5px' }}>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12'><button className='btn' style={{ backgroundColor: '#41B8E4', color: 'white' }}>Submit</button></Col>
                            </Row>
                        </Col>
                    </Row>

                </Col>
            </Row>
        </div>
  )}
        </>
    );
};

export default ReloadGiftCard;
